import { makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";

export class PaymentStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "PaymentStore",
      properties: ["policyId", "duePayment", "reccPmntID", "reccPmntExpiry", "insurerId", "provider", "upcToken", "cardNumber"],
      storage: typeof document !== "undefined" ? window.localStorage : null
    });
  }

  policyId = "";

  insurerId = "";

  duePayment = "";

  reccPmntID = "";

  reccPmntExpiry = "";

  requestId = "";

  paymentId = "";

  upcToken = "";

  cardNumber = "";

  isPolicyPending = false;

  async set(name, value) {
    this[name] = value;
  }

  reset() {
    this.policyId = "";
    this.requestId = "";
    this.paymentId = "";
    this.duePayment = "";
    this.reccPmntID = "";
    this.reccPmntExpiry = "";
    this.insurerId = "";
    this.provider = "";
    this.upcToken = "";
    this.cardNumber = "";
    this.isPolicyPending = false;
  }
}
const payment = new PaymentStore();
export default payment;
